import React from 'react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { Key, Sparkles } from 'lucide-react';
export const ModeSwitcherButton = ({ mode, onChange }) => {
    const { t } = useTranslation();
    return (<Button variant="outline" type="button" className="w-full" onClick={() => onChange(mode === 'password' ? 'magic' : 'password')}>
            {mode === 'password' ? (<React.Fragment>
                    <Sparkles />
                    {t('use_magic_link', { defaultValue: 'Sign in with a magic link' })}
                </React.Fragment>) : (<React.Fragment>
                    <Key />
                    {t('use_password', { defaultValue: 'Sign in with password' })}{' '}
                </React.Fragment>)}
        </Button>);
};
ModeSwitcherButton.displayName = 'ModeSwitcherButton';
